<template>
  <div class="bg">
    <div class="listWrapper">
      <div
        class="listBox"
        :key="item.id"
        v-for="item in companyList"
        @click="addCompanyCard(item.id)"
      >
        <div class="companyName">{{ item.companyName }}</div>
      </div>
    </div>
    <div class="add" @click="goAddCompany">
      <img src="../../assets/add@2x.png" />
    </div>
  </div>
</template>

<script>
import { getCompanyList } from "../../api/identify";

export default {
  data() {
    return {
      companyList: [],
      params: {
        companyId: "",
        name: "",
        phone: "",
        registerId: ""
      }
    };
  },
  created() {
    this.getCompanyList();
  },
  methods: {
    goAddCompany() {
      this.$router.push({ path: "/identify/companyIdentify" });
    },
    addCompanyCard(id) {
      this.$router.push({ path: "/bankCard/addCompanyBankCard/" + id });
    },
    getCompanyList() {
      let that = this;
      getCompanyList()
        .then(res => {
          if (res) {
            that.companyList = res;
          }
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style>
.bg {
  background: #f3f3f3;
}
.listWrapper {
  background: #fff;
  overflow: hidden;
}
.listBox {
  padding: 30px 0;
  margin: 0 30px;
  border-bottom: 1px solid #e6e6e6;
  overflow: hidden;
}
.companyName {
  font-size: 15px;
  line-height: 40px;
  float: left;
}
.add {
  position: fixed;
  width: 90px;
  height: 90px;
  right: 40px;
  bottom: 120px;
  overflow: hidden;
}
.add img {
  width: 100%;
  height: 100%;
}
</style>
